function initAccordion() {
  $(".accordion .question").click(function() {
      if ($(this).parent("li").hasClass("open") == false) {
          $(this).parents(".accordion").find(".answer").slideUp();
          $(this).parents(".accordion").find("li").removeClass("open");

          $(this).next(".answer").slideDown();
          $(this).parent(".accordion li").addClass("open");
      } else {
          $(this).parents(".accordion").find(".answer").slideUp();
          $(this).parents(".accordion").find("li").removeClass("open");
      }
  })
}
initAccordion();
document.addEventListener('pdp-accordion:init',initAccordion)

/* sticky Bar */
function stickyHeight(){
  $(".product_variant_grouping_new").css("min-height","");
  var product_variant_grouping_new = $(".product_variant_grouping_new").outerHeight(true);
  $(".product_variant_grouping_new").css("min-height",product_variant_grouping_new+"px");
}
stickyHeight();
$(window).resize(function(){
  stickyHeight();
});

document.addEventListener('stickyHeight:init',stickyHeight)

if($(".nss_product_latest_main_new").length > 0)
  {
    var stickyHeaderTopSticky = $(".nss_product_latest_main_new").offset().top +  $(".nss_product_latest_main_new").outerHeight(true) - $("#shopify-section-header").outerHeight(true);
    $(window).scroll(function(){
      if( $(window).scrollTop() > stickyHeaderTopSticky ) {
          if($('body').hasClass("sticky_header_new") == false)
          {
              $('body').addClass("hide_atc_button_new");
              setTimeout(function(){
                $('body').addClass("delay_sticky_header_new");
              }, 100);
              setTimeout(function(){
                $('body').addClass('sticky_header_new');
              }, 400);
          }
      } else {
          if ($('body').hasClass("sticky_header_new")) {
            $('body').removeClass("sticky_header_new");
            setTimeout(function(){
              $('body').removeClass("hide_atc_button_new");
              $("body").removeClass("delay_sticky_header_new");  
            }, 400);
          }
      }
    });
  }

function productPageScript(){

  /* Sticky Variant */
  $(".product_grouping_list_title_new").click(function() {
    if($(this).parents(".product_grouping_list_inner_new").find(".product_grouping_list_mainloops_new").hasClass("active") == false){
      $(".variant_box_new fieldset").removeClass("active");
      $(".product_grouping_list_mainloops_new").removeClass("active");
      $(this).parents(".product_grouping_list_inner_new").find(".product_grouping_list_mainloops_new").addClass("active");
    }
    else{
      $(".product_grouping_list_mainloops_new").removeClass("active");
    }
  })

  $(".product_grouping_list_innerloops_mainboxs_new").click(function() {
    $(".product_grouping_list_mainloops_new").removeClass("active");
  })
  
  $(".custom_variant-option-label").click(function() {
    if($(this).parents(".variant_box_new").find("fieldset").hasClass("active") == false){
      $(".variant_box_new fieldset").removeClass("active");
      $(".product_grouping_list_mainloops_new").removeClass("active");
      $(this).parents(".variant_box_new").find("fieldset").addClass("active");
    }
    else{
      $(".variant_box_new fieldset").removeClass("active");
    }
  })

  $(".variant_label_new").click(function() {
    $(".variant_box_new fieldset").removeClass("active");
  })

  $(document).mouseup(function(e) 
  {
      var container = $(".product_grouping_list_main_new, .variant_box_new");

      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) 
      {
          $(".product_grouping_list_mainloops_new").removeClass("active");
          $(".variant_box_new fieldset").removeClass("active");
      }
  });

  /* Read More */
  $(".read_more_open").click(function name() {
    $(this).parents(".nss_short_description_inner_new").addClass("active");
  })

  /* Play Video */
  $(".play_icon_new").click(function(){
    if($(this).hasClass("active") == false)
    {
      $(this).parents(".video_play_list").find(".play_icon_new").removeClass("active");
      $(this).parents(".video_play_list").find('video').trigger('pause');
      $(this).parents(".video_play_list").find(".play_icon").css("display","block");
      
      $(this).addClass("active");
      var URL = $(this).find('video').attr("video_url");
      if($(this).find('video').attr("src") == null)
      {
        $(this).find('video').attr("src",URL);
      }
      $(this).find('video').trigger('play');
      $(this).siblings().find('video').trigger('pause');
      $(this).siblings().find('.play_icon').css("display","block");
      $(this).find(".play_icon").css("display","none");
    }
    else
    {
      $(this).removeClass("active");
      $(this).find('video').trigger('pause');
      $(this).find(".play_icon").css("display","block");
    }
  })

  /* Size Guide Popup */
  $(".open_size_guide").click(function () {
    $('body').addClass("overflow-hidden");
    $(".size_chart_overlay_new").fadeIn();
    $(".size_chart_main_new").addClass("open");
  })
  $(".size_chart_overlay_new, .size_chart_inner_close_new").click(function () {
    $('body').removeClass("overflow-hidden");
    $(".size_chart_overlay_new").fadeOut();
    $(".size_chart_main_new").removeClass("open");
  })

  $(".size_chart_dropdown_title_new").click(function() {
    if($(this).parents(".size_chart_dropdown_new").find(".size_chart_dropdown_list_new").hasClass("active") == false){
      $(".size_chart_dropdown_list_new fieldset").removeClass("active");
      $(this).parents(".size_chart_dropdown_new").find(".size_chart_dropdown_list_new").addClass("active");
    }
    else{
      $(".size_chart_dropdown_list_new").removeClass("active");
    }
  })
  $(".size_chart_dropdown_list_inner_new").click(function() {
    var country_attr = $(this).attr("country");
    var country_name_attr = $(this).attr("country_name");
    $(".country_details_new").removeClass("active");
    $("."+country_attr+"_display").addClass("active");
    $(".size_chart_dropdown_title_new span").html(country_name_attr);
    $(".size_chart_dropdown_list_new").removeClass("active");
  })

  $(document).mouseup(function(e) 
  {
      var container = $(".size_chart_dropdown_new");

      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) 
      {
          $(".size_chart_dropdown_list_new").removeClass("active");
      }
  });

  // fansybox
  Fancybox.bind("[data-fancybox]", {
    Toolbar: true,
    smallBtn: true,
    Carousel: {
      Thumbs: false,
    },
    video: {
      autoStart: false,
    },
  });
}
productPageScript()
document.addEventListener('productPageScript:init', productPageScript)


/* Product Slider */
function productMediaSliderInit() {
  var thumbsSwiper = new Swiper('.product-thumbs-swiper', {
    loop: false,
    grabCursor: false,
    spaceBetween: 16,
    slidesPerGroup: 1,
    slidesPerView: 6,
    watchSlidesProgress: true,
    draggable: !0,
    autoHeight: !1,
    watchOverflow: !0,
    threshold: 10,
    mousewheel: {
        forceToAxis: !0
    },
    slideToClickedSlide: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    breakpoints: {
      0: {
        slidesPerView: 5,
        spaceBetween: 10
      },
      750: {
        slidesPerView: 5,
        spaceBetween: 10
      },
      990: {
        slidesPerView: 5,
        spaceBetween: 12
      },
      1376: {
        slidesPerView: 6,
        spaceBetween: 16
      }
    }
  });
  var mainSwiper = new Swiper('.product-main-swiper', {
    loop: false,
    grabCursor: false,
    spaceBetween: 10,
    slidesPerGroup: 1,
    slidesPerView: 1,
    watchSlidesProgress: true,
    draggable: !0,
    autoHeight: !1,
    watchOverflow: !0,
    threshold: 10,
    mousewheel: {
        forceToAxis: !0
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    thumbs: {
      swiper: thumbsSwiper
    }
  });
}

productMediaSliderInit();
document.addEventListener('product-media-slider:init', productMediaSliderInit)


/* nss_object_custom_reviews_slider */
function nsProductReviewInit() {
  new Swiper('.nss_object_custom_reviews_slider', {
    loop: true,
    grabCursor: false,
    spaceBetween: 50,
    slidesPerGroup: 1,
    slidesPerView: 1,
    watchSlidesProgress: true,
    draggable: !0,
    autoHeight: !1,
    watchOverflow: !0,
    threshold: 10,
    mousewheel: {
        forceToAxis: !0
    },
    /*freeMode: !0,*/
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    observer: true,
    observeParents: true,
    breakpoints: {
      0: {
        /*freeMode: !1*/
      },
      750: {
      },
      990: {
      },
      1440: {
      }
    }
  })
}

nsProductReviewInit();
document.addEventListener('ns-product-review:init', nsProductReviewInit)


/* nss_product_meta_gallery_slider */
function nssProductGallerySliderInit() {
  new Swiper('.nss_product_meta_gallery_slider', {
    loop: false,
    grabCursor: false,
    spaceBetween: 20,
    slidesPerGroup: 1,
    slidesPerView: 3,
    watchSlidesProgress: true,
    draggable: !0,
    autoHeight: !1,
    watchOverflow: !0,
    threshold: 10,
    mousewheel: {
        forceToAxis: !0
    },
    freeMode: !0,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    observer: true,
    observeParents: true,
    breakpoints: {
      0: {
        freeMode: !1,
        slidesPerView: "auto"
      },
      750: {
        slidesPerView: 3
      },
      990: {
      },
      1440: {
      }
    }
  })
}

nssProductGallerySliderInit();
document.addEventListener('nssProductGallerySliderInit',nssProductGallerySliderInit)


/* nss_reviews_with_images_slider */
function nssReviewsWithImagesSliderInit() {
  new Swiper('.nss_reviews_with_images_slider', {
    loop: true,
    grabCursor: true,
    spaceBetween: 20,
    slidesPerGroup: 2,
    slidesPerView: "auto",
    watchSlidesProgress: true,
    draggable: !0,
    autoHeight: !1,
    watchOverflow: !0,
    threshold: 10,
    mousewheel: {
        forceToAxis: !0
    },
    centeredSlides: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      0: {
        slidesPerGroup: 1
      },
      750: {
        slidesPerGroup: 1
      },
      990: {
        slidesPerGroup: 2
      },
      1440: {
      }
    }
  })
}

nssReviewsWithImagesSliderInit();
document.addEventListener('nss-reviews-with-images-slider:init',nssReviewsWithImagesSliderInit)
